
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6bbfe3b6!stylus-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./settingsTab.vue")
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6bbfe3b6&scoped=true!sass-loader?{\"api\":\"modern\",\"sassOptions\":{\"quietDeps\":true},\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./settingsTab.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./settingsTab.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6bbfe3b6!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./settingsTab.vue"),
  /* scopeId */
  "data-v-6bbfe3b6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/onlineRoundtables/tabs/settingsTab.vue
// module id = 353
// module chunks = 61